<nav class="navbar titlebar2" style="align-items: center;
  justify-content: flex-start; width: 100%;">
    <!-- Brand/logo -->
    <img src="assets/images/logo.png" width="70" />
    <!-- Links -->
    <ul class="navbar-nav">
        <li class="nav-item">
            <div class="contentheader">สถาบันคุ้มครองเงินฝาก</div>
            <div class="contentheader2">Deposit Protection Agency
            </div>
        </li>
    </ul>
</nav>
<br />
<div class="row centered-content">
    <div class="col-10 cl-md-4 col-lg-4">
        <div class="content-body" style="background-color: whitesmoke;">
            <div class="row m-3">
                <div class="col-12 centered-content ">
                    <h3>กรุณาเปลี่ยนรหัสผ่าน</h3>
                </div>
            </div>
            <div class="row m-3">
                <div class="col-md-4 text-right">
                    <label>รหัสผ่านใหม่</label>
                </div>
                <div class="col-md-8">
                    <input type="password" class="form-control" id="NewPassword">
                </div>
            </div>
            <div class="row m-3">
                <div class="col-md-4 text-right">
                    <label>ยืนยันรหัสผ่าน</label>
                </div>
                <div class="col-md-8">
                    <input type="password" class="form-control" id="ConfirmPassword">
                    <span style="color: red;" id="lblPwdError"></span>
                </div>
            </div>
            <div class="row m-3">
                <div class="col-12">
                    1. ตั้งรหัสผ่านใหม่ เป็นภาษาอังกฤษความยาว 8 ถึง 16 ตัวอักษร
                </div>
            </div>
            <div class="row m-3">
                <div class="col-12">
                    2. โดยจะต้องมีอักษรตัวใหญ่ (A-Z) และตัวเล็ก (a-z)
                </div>
            </div>
            <div class="row m-3">
                <div class="col-12">
                    3. ตัวเลข (0-9) และอักขระพิเศษ (!,@,...) ผสมกัน
                </div>
            </div>
            <div class="row m-3">
                <div class="col-12 centered-content">
                    <button class="btn btn-default" id="Save" (click)="Save()">บันทึก</button>
                </div>
            </div>
        </div>
    </div>
</div>

<footer class="footer mt-auto">
    <img src="../../assets/images/footer.png" style="width: 100%;">
</footer>


// WEBPACK FOOTER //
// ./src/app/account/reset-password/reset-password.component.html